import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "8598c0ea-bd59-46eb-b0bb-fc22c7cb0487",
    content: "The flanking path sound level is always lower than the direct path sound level.",
    options: {},
  },
  {
    id: "78c0d242-0c00-44d1-b796-e43e2a1fcdae",
    content: "The final impulse response depends on the properties of the source room. ",
    options: {},
  },
  {
    id: "0c7b161f-0f2e-48aa-98af-dd9f50e4869a",
    content: "The final impulse response depends on the properties of the receiver room. ",
    options: {},
  },
  {
    id: "015f157a-fa5a-4061-b288-604a1039e4f4",
    content: "The final impulse response depends highly on the dimension of the wall elements. ",
    options: {},
  },
  {
    id: "0baa067f-05ae-4932-b110-c23a1241ca42",
    content: "A wall is typically acting as a low pass filter.",
    options: {},
  },
  {
    id: "a103bf22-59b0-450b-a8e9-4d9957a8e3c8",
    content: "A wall is typically acting as a high pass filter.",
    options: {},
  },
];

export const task: Task = {
  id: "3d8d973e-afb8-40f0-bb23-86e40503ff34",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "78c0d242-0c00-44d1-b796-e43e2a1fcdae",
    "0c7b161f-0f2e-48aa-98af-dd9f50e4869a",
    "015f157a-fa5a-4061-b288-604a1039e4f4",
    "0baa067f-05ae-4932-b110-c23a1241ca42",
  ],
};
